import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the home state domain
 */

const selectHomeDomain = (state) =>
  state.get("AdministratorCompaniesHome", initialState)

/**
 * Other specific selectors
 */

export const makeSelectIsLoading = () =>
  createSelector(selectHomeDomain, (state) => state.get("isLoading"))

export const makeSelectCompanies = () =>
  createSelector(selectHomeDomain, (state) => state.get("companies"))

export const makeSelectOptions = () =>
  createSelector(selectHomeDomain, (state) => state.get("options"))

export const makeSelectSearchLoading = () =>
  createSelector(selectHomeDomain, (state) => state.get("searchLoading"))

export const makeSelectSearchResult = () =>
  createSelector(selectHomeDomain, (state) => state.get("searchResult"))
/**
 * Default selector used by Home
 */

const makeSelectHome = () =>
  createSelector(selectHomeDomain, (substate) => substate.toJS())

export default makeSelectHome
export { selectHomeDomain }
